export default __webpack_public_path__ + "static/media/dfg_logo_englisch_blau_en.bbf1ca04.jpg";